@if (pageAlert$ | async; as pageAlert) {
  @if (!!showBanner && !!pageAlert.hide === false) {
    <fss-app-alert
      [alert]="pageAlert"
      (ctaClick)="onCtaClick($event)"
      (dismissAlert)="onDismissAlert($event)"
    ></fss-app-alert>
  }
}
